/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_SideInputs */

const en_us2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which side?`)
};

const pt_br2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual lado?`)
};

const es_419_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿De qué lado?`)
};

const pt_pt2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que lado?`)
};

const fr_fr2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel côté ?`)
};

const de_de2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Seite?`)
};

const it_it2_profile_editors_pain_side = /** @type {(inputs: Profile_Editors_Pain_SideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quale lato?`)
};

/**
* | output |
* | --- |
* | "Which side?" |
*
* @param {Profile_Editors_Pain_SideInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_side = /** @type {((inputs?: Profile_Editors_Pain_SideInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_SideInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_side(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_side(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_side(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_side(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_side(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_side(inputs)
	return en_us2_profile_editors_pain_side(inputs)
});
export { profile_editors_pain_side as "profile-editors.pain_side" }